import React, { Component } from "react";
import {
  Button,
  Confirm,
  Modal,
  Checkbox,
  Divider,
  Form,
  Segment,
  Message,
  List,
  Icon,
  Input,
  Loader
} from "semantic-ui-react";
import Flatpickr from "react-flatpickr";
import ReactTable from "react-table";

import { AppContext } from "../../utils/context";
import request from "../../utils/request";

const dateTimePicker = {
  enableTime: true,
  dateFormat: "Y-m-d h:i K"
};

const RenderSelected = props => (
  <div className="content">
    <p>
      <strong>{props.title}</strong>
    </p>
    {Object.values(props.selected).map(v => (
      <div key={v}>{v}</div>
    ))}
  </div>
);

class EventTickets extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      selected: {},
      restoreSelected: {},
      voidSelected: {},
      selectAll: 0,
      selectedPaymentType: "",
      selectedSubType: "",
      data: [],
      pages: null,
      isLoading: true,
      ticketsLoading: false,
      confirm: {
        ids: [],
        content: "",
        isOpen: false,
        isDone: this.confirmClose
      },
      modal: {
        ids: [],
        content: "",
        isOpen: false,
        isDone: this.confirmModalClose
      },
      eventId: this.props.match.params.id,
      limit: 100,
      page: 1,
      sorted: [],
      filtered: {
        queryKey: "",
        queryValue: "",
        startTime: "",
        endTime: "",
        printers: []
      },
      printerOptions: [],
      envelope: 0,
      invalidEnvelope: true,
      freeTicketMessage: "",
      freeTicketEnabled: context && context.config ? context.config.free_tickets_enabled : false,
      password: "",
      xhrStatus: "",
      xhrMessages: [],
      eventHasWinner: false,
      eventDeckSize: 0,
      allowManagerVoid: context.config.manager_void_after_draw_enabled,
      userIsSuper: false,
      ticketNumbers: [],
      expanded: {},
      rowIndex: -1,
      resendEmailId: "",
      resendEmailStatus: "",
      web_enabled: context && context.config ? context.config.web_sales_enabled : false,
      gameId: 0,
      handpoint_refunds_enabled: context && context.config ? context.config.handpoint_refunds_enabled : true
    };

    this.fetchWinner = this.fetchWinner.bind(this);
    this.fetchData = this.fetchData.bind(this, props);
    this.confirmOpen = this.confirmOpen.bind(this);
    this.confirmClose = this.confirmClose.bind(this);
    this.confirmModalOpen = this.confirmModalOpen.bind(this);
    this.confirmModalClose = this.confirmModalClose.bind(this);
    this.toggleSelectAll = this.toggleSelectAll.bind(this);
    this.closeFreeTicketMessageModal = this.closeFreeTicketMessageModal.bind(this);
    this.handleFreeTicketException = this.handleFreeTicketException.bind(this);
  }
  componentDidMount = () => {
    this.fetchWinner();
    this.fetchData();
  };
  componentDidUpdate = prevProps => {
    // Typical usage (don't forget to compare props):
    if (this.props.eventId !== prevProps.eventId) {
      let self = this;
      this.setState(
        {
          data: [],
          pages: null,
          isLoading: true,
          expanded: {},
          rowIndex: -1,
          eventId: this.props.eventId,
          limit: 100,
          page: 0,
          sorted: [],
          filtered: {
            queryKey: "",
            queryValue: "",
            startTime: "",
            endTime: ""
          },
          gameId: 0
        },
        () => self.fetchData()
      );
    }
  };
  startLoading = () => {
    this.setState({ isLoading: true });
  };
  doneLoading = () => {
    this.setState({ isLoading: false, expanded: {}, rowIndex: -1 });
  };
  fetchData = async (props) => {
    this.startLoading();
    const { eventId, limit, page, sorted, filtered } = this.state;

    // Fetch user details
    let user = await request.get(this, "api:/user", {});

    let payload = {
      eventId: eventId,
      limit: limit,
      page: page,
      sorted: sorted,
      filtered: filtered,
      ts: Date.now()
    };

    let callback = this.context.config.backend_type === "bep" ? this.fetchPrinters : this.doneLoading;

    return request.get(this, `api:/event/${eventId}/payments`, payload).then(res => {
      // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
      this.setState(
        {
          data: res.data,
          pages: Math.ceil(res.total / this.state.limit),
          userIsSuper: +user.superadmin === 1 ? true : false,
          freeTicketEnabled: this.context.config.free_tickets_enabled
        },
        callback
      );
    });

  };
  fetchWinner = () => {
    const { eventId } = this.state;
    return request.get(this, `api:/event/${eventId}`).then(resp => {
      this.setState({
        eventDeckSize: resp.decksize,
        eventHasWinner: resp.haswinner,
        gameId: resp.game_id
      });
    });
  };
  fetchPrinters = () => {
    return request.get(this, "api:/drum-printer", {}).then(resp => {
      let printerSelect = [];
      if (resp && resp.status !== "error") {
        resp.map(v => {
          return printerSelect.push({
            id: v.id,
            value: v.id,
            text: v.host
          });
        });
      }
      this.setState({ printerOptions: printerSelect }, () => this.doneLoading());
    });
  };
  confirmOpen = (id, title, callback, index) => {
    if (index === "voidTicketsBtn") {
      if (this.state.selectedPaymentType === "credit_card") {
        if (this.state.selectedSubType === "aliant") {
          title = `Warning: This will void the entire order. You will have to issue the refund manually. Are you sure you want to void this transaction?`
        }
        else {
          title = `Warning: This will void and refund the entire order. Are you sure you want to void this transaction?`
        }
      }
    }
    if (!callback) callback = this.confirmClose;
    if (!this.state.confirm.isOpen) {
      this.setState({
        confirm: {
          ids: id,
          content: title,
          isOpen: true,
          isDone: callback
        }
      });
    }
  };
  confirmClose = callback => {
    this.setState(
      {
        confirm: {
          ids: [],
          content: "",
          isOpen: false,
          isDone: this.confirmClose
        }
      },
      callback
    );
  };
  confirmModalOpen = (id, title, callback) => {
    if (!callback) callback = this.confirmModalClose;
    if (!this.state.modal.isOpen) {
      this.setState({
        freeTicketEnabled: true,
        freeTicketMessage: "",
        modal: {
          ids: id,
          content: title,
          isOpen: true,
          isDone: callback
        }
      });
    }
  };
  confirmModalClose = callback => {
    this.setState(
      {
        modal: {
          ids: [],
          content: "",
          isOpen: false,
          isDone: this.confirmModalClose
        },
        envelope: 0
      },
      callback
    );
  };
  closeFreeTicketMessageModal = () => {
    this.setState({ freeTicketMessage: "" });
  }
  handleExport = () => {
    return request.getDownload(
      this,
      `api:/event/${this.state.eventId}/payment-export`,
      {}
    );
  };
  handleFilter = (e, { name, value }) => {
    let filters = this.state.filtered;
    filters[name] = value;
    this.setState({ filtered: filters });
  };
  handleClearSearch = (e, { name, value }) => {
    let filters = this.state.filtered;
    filters.queryKey = "";
    filters.queryValue = "";
    filters.startTime = "";
    filters.endTime = "";
    this.setState({filtered: filters}, () => this.fetchData());
  };
  handlePageChange = activePage => {
    this.setState({ page: activePage + 1 }, () => this.fetchData());
  };
  handleLimitChange = pageSize => {
    this.setState({ limit: pageSize, page: 1 }, () => this.fetchData());
  };
  freeTicket = () => {
    this.setState({ freeTicketEnabled: false });

    let payload = { confirm: 1 };
    if (this.state.gameId === 3) {
      if (this.state.envelope === 0) {
        this.handleFreeTicketException("Please select an envelope number for the Free Ticket.");
      } else {
        payload.envelope = this.state.envelope;
      }
    }
    // make sure the selected envelope hasn't already been drawn
    return request.post(this, "api:/event/" + this.state.eventId + "/free-tickets", payload).then(resp => {
      if(resp.exception || resp.status === "error") {
        this.handleFreeTicketException(resp.message);
      } else {
        this.confirmModalClose(this.fetchData);
      }
    });
  };
  handleFreeTicketException = (message) => {
    this.setState({
      modal: { content: "ERROR" },
      freeTicketMessage: message,
      freeTicketEnabled: false
    });
  }

  restoreTickets = () => {

    this.confirmClose();

    let promises = [];
    let payloads = [];
    let isSelected = this.state.restoreSelected;

    // Cannot restore CC purchases
    this.state.data.forEach(x => {
      if (isSelected[x.id] === true && x.subtype !== "shopify" && x.subtype !== "handpoint" && (x.status === "refunded" || x.status === "void")) {
        payloads.push({
          paymentId: x.id,
          paymentStatus: x.status
        });
      }
    });

    if (payloads.length > 0) {

      this.startLoading();

      promises.push(request.post(this, `api:/event/${this.state.eventId}/payment-restore`, payloads));

      Promise.all(promises)
        .then(values => {
          if (values[0].status === 'error') {
            this.setState({
              xhrStatus: values[0].status,
              xhrMessages: [values[0].message]
            });
          } else {
            this.setState({
              xhrStatus: 'success',
              xhrMessages: ['Payment(s) restored']
            });
          }

          return true;
        })
        .then(done => {
          this.toggleSelectAll();
        });
    }
  };

  voidTickets = () => {

    this.confirmClose();

    // can't void a ticket if a draw has NOT been run yet && user is NOT a superadmin
    if ((!this.state.eventHasWinner && !this.state.userIsSuper) || this.state.userIsSuper || this.state.allowManagerVoid) {

      let payloads = [];
      const isSelected = this.state.voidSelected;

      this.state.data.forEach(x => {
        if (isSelected[x.id] === true && x.status !== "refunded" && x.status !== "void" && x.subtype !== "shopify"  && (x.subtype !== "handpoint" || this.state.handpoint_refunds_enabled)) {
          payloads.push({
            paymentId: x.id,
            paymentStatus: x.status
          });
        }
      });

      if (payloads.length > 0) {
        this.startLoading();
        this.handleVoidRequest(payloads);
      }
    }
  };

  toggleRow(id, status, subtype) {
    let newSelected = Object.assign({}, this.state.selected);
    let newRestoreSelected = Object.assign({}, this.state.selected);
    let newVoidSelected = Object.assign({}, this.state.selected)
    newSelected[id] = !this.state.selected[id];
    if (status === "void" || status === "refunded") {
      newRestoreSelected[id] = newSelected[id];
    }
    if (status !== "void" || status === "refunded") {
      newVoidSelected[id] = newSelected[id];
    }
    this.setState({
      selected: newSelected,
      restoreSelected: newRestoreSelected,
      voidSelected: newVoidSelected,
      selectAll: 2,
      selectedPaymentType: status,
      selectedSubType: subtype
    });
  }

  toggleSelectAll = () => {
    let newSelected = {};

    if (this.state.selectAll === 0) {
      this.state.data.forEach(x => {
        newSelected[x.id] = true;
      });
    }

    this.setState({
      selected: newSelected,
      selectAll: this.state.selectAll === 0 ? 1 : 0
    }, () => this.fetchData());
  }
  handleChange = (e, { name, value }) => {
    if (name === "envelope") {
      if (+value < 0) {
        value = 0;
      } else if (+value % 1 != 0) {
        value = Math.floor(+value);
      } else if (+value > this.state.eventDeckSize) {
        value = this.state.eventDeckSize;
      }
    }

    this.setState({ [name]: value, invalidEnvelope: (name === "envelope" && +value <= 0) ? true : false });
  };
  handleOnExpand = (index) => { // handle payment row expansion - fetch ticket numbers
    const { data, rowIndex, eventId } = this.state;
    if (rowIndex !== index) {
        let payload = {
            paymentId: data[index].id
        };
        request.get(this, `api:/event/${eventId}/payment-tickets`, payload).then(resp => {
            this.setState({ ticketNumbers: resp, rowIndex: index, ticketsLoading: false });
        });
    }
  };
  handleResendEmail = (id, email) => {
    let payload = {
      id: id,
      email: this.state.resendEmailId !== "" ? this.state.resendEmailId : email
    };
    request.post(this, "api:/event/resend-order-email", payload).then(resp => {
      this.setState({ resendEmailStatus: resp.status });
    });
  }

  handleVoidRequest = (payload) => {
    this.startLoading();

    let promises = [];
    promises.push(request.post(this, `api:/event/${this.state.eventId}/payment-void`, payload));

    Promise.all(promises)
      .then(values => {
        if (values[0].status === 'error') {
          this.setState({
            xhrStatus: values[0].status,
            xhrMessages: [values[0].message]
          });
        } else {
          this.setState({
            xhrStatus: 'success',
            xhrMessages: ['Payment(s) voided/refunded']
          });
        }

        return true;
      })
      .then(done => {
        this.toggleSelectAll();
      });
  }

  handleMarkAsVoid = (id, status) => {
    let payload = [{
      paymentId: id,
      paymentStatus: status
    }];
    this.handleVoidRequest(payload);
  }

  render() {
    const {
      confirm,
      modal,
      data,
      filtered,
      pages,
      limit,
      isLoading,
      printerOptions,
      selected,
      xhrMessages,
      xhrStatus,
      web_enabled,
      invalidEnvelope,
      freeTicketEnabled
    } = this.state;
    const columns = [
      {
        expander: true,
        Header: () => <strong>More</strong>,
        width: 65,
        Expander: ({ isExpanded, ...rest }) => (
          <div>
            {isExpanded ? (
              <Icon name="caret down" />
            ) : (
                <Icon name="caret right" />
              )}
          </div>
        ),
        style: {
          cursor: "pointer",
          fontSize: 25,
          padding: "0",
          textAlign: "center",
          userSelect: "none"
        }
      },
      {
        Header: x => {
          return (
            <Checkbox
              label="Select all"
              onChange={this.toggleSelectAll}
              checked={this.state.selectAll === 1}
              defaultIndeterminate={this.state.selectAll === 2}
            />
          );
        },
        id: "id",
        sortable: false,
        width: 125,
        accessor: d => {
          return (
            <Checkbox
              label={false}
              onChange={() => this.toggleRow(d.id, d.status, d.subtype)}
              checked={this.state.selected[d.id] === true}
            />
          );
        }
      },
      {
        Header: "Time",
        id: "purchase_time",
        accessor: "purchase_time"
      },
      {
        accessor: d => `${d.first_name} ${d.last_name}`,
        id: "first_name",
        Header: "Seller"
      },
      {
        Header: "Price Point",
        id: "amount",
        accessor: d => `${d.quantity} for $${d.amount}`
      },
      {
        Header: "Payment",
        id: "payment_type",
        accessor: "payment_type"
      },
      {
        Header: "Status",
        id: "status",
        accessor: "status",
        width: 125
      }
    ];
    let hasSelected = 0;
    Object.values(selected).forEach(v => v ? hasSelected++ : v);
    let selectedRestoreList = [];
    let selectedVoidList = [];
    let preventContinue = false;
    let isChecked = false;
    let canVoid = false;
    let canRestore = false;


    Object.entries(selected).forEach((entry) => {
      Object.values(this.state.data).forEach(v => {
        isChecked = +entry[0] === v.id && entry[1] === true;
        canVoid = v.subtype !== "shopify" && (v.subtype !== "handpoint" || this.state.handpoint_refunds_enabled) && v.payment_type !== "debit_card";
        canRestore = v.subtype !== "shopify" && v.subtype !== "handpoint" && v.subtype !== "clover" && v.subtype !== "shift4" && v.subtype !== "paysafe";

        if (isChecked) {
          if ((v.status === "void" || v.status === "refunded") && canRestore) {
            selectedRestoreList.push(entry[0]);
          } else if (((v.status === "void" || v.status === "refunded") && selectedRestoreList.length > 0)
            || ((v.status === "void" || v.status === "refunded") && !canRestore))
          {
            preventContinue = true;
          }

          if ((v.status !== "void" && v.status !== "refunded") && canVoid) {
            selectedVoidList.push(entry[0]);
          } else if (((v.status !== "void" || v.status !== "refunded") && selectedVoidList.length > 0) ||
            ((v.status !== "void" && v.status !== "refunded") && !canVoid))
          {
            preventContinue = true;
          }
        }

        if (selectedVoidList.length >= 1 && selectedRestoreList.length >= 1) {
          // can't restore and void in the same action
          preventContinue = true;
        }
      });
    });

    if (preventContinue) {
      selectedVoidList = [];
      selectedRestoreList = [];
    }

    let searchable = [
      { value: "customers", text: "Customers"},
      { value: "deviceIds", text: "Device IDs"},
      { value: "deviceNames", text: "Device Names"},
      { value: "webOrderIds", text: "Order IDs"},
      { value: "processors", text: "Payment Processors"},
      { value: "payments", text: "Payment References"},
      { value: "payAmounts", text: "Price"},
      { value: "sellerIds", text: "Seller IDs"},
      { value: "sellerLogins", text: "Seller Logins"},
      { value: "sellerNames", text: "Seller Names"},
      { value: "tickets", text: "Ticket Numbers"},
      { value: "reprintOrders", text: "Reprint Orders"}
    ];
    return (
      <Segment basic>
        <Confirm
          open={confirm.isOpen}
          content={confirm.content}
          cancelButton="Cancel"
          confirmButton="Confirm"
          onCancel={() => this.confirmClose()}
          onConfirm={confirm.isDone}
        />
        <Modal
          open={modal.isOpen}
          closeIcon
          onClose={() => this.confirmModalClose()}
        >
          <Modal.Header content={modal.content} />
          {this.state.gameId === 3 && this.state.freeTicketMessage === "" && (
          <Modal.Content>
            <p>Pick an envelope:</p>
            <br/>
            <Input
              label="envelope #"
              type="number"
              name="envelope"
              onChange={this.handleChange}
              value={this.state.envelope}
            />
          </Modal.Content>
          )}
          <Modal.Content>
            <p>{this.state.freeTicketMessage}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button negative onClick={() => this.confirmModalClose()}>
              Cancel
            </Button>
            {this.state.gameId === 3 ? (
            <Button positive onClick={() => modal.isDone()} disabled={invalidEnvelope || !freeTicketEnabled}>
              Confirm
            </Button>
            ) : (
            <Button positive onClick={() => modal.isDone()} disabled={!freeTicketEnabled}>
              Confirm
            </Button>
            )}
          </Modal.Actions>
        </Modal>
        <Form
          error={xhrStatus === "error"}
          success={xhrStatus === "success"}
        >
          <Message
          error
          content={xhrMessages.map((item, key) => {
            return (
              <span key={`error${key}`}>
                {item}
                <br />
              </span>
            );
          })}
        />
        <Message
          success
          content={xhrMessages.map((item, key) => {
            return (
              <span key={`success${key}`}>
                {item}
                <br />
              </span>
            );
          })}
          />
          <Form.Group widths='equal'>
            {this.context.config.backend_type === "bep" && (
              <Form.Select
                name="printers"
                placeholder="All Printer(s)"
                options={printerOptions}
                value={filtered.printers}
                multiple
                onChange={this.handleFilter}
              />
            )}
            <Form.Select
              name="queryKey"
              placeholder="Search key"
              value={filtered.queryKey}
              options={searchable}
              onChange={this.handleFilter}
              className="ticketsGroupSearch"
            />
            <Form.Input
              name="queryValue"
              placeholder="Search..."
              value={filtered.queryValue}
              onChange={this.handleFilter}
              className="ticketsGroupSearch"
            />
            <Form.Field className="ticketsGroupSearch">
              <Flatpickr
                name="startTime"
                placeholder="From"
                value={filtered.startTime}
                autoComplete="off"
                options={dateTimePicker}
                onChange={(_, str, b) =>
                  this.handleFilter(b.element, {
                    name: "startTime",
                    value: str
                  })
                }
              />
            </Form.Field>
            <Form.Field className="ticketsGroupSearch">
              <Flatpickr
                name="endTime"
                placeholder="To"
                value={filtered.endTime}
                autoComplete="off"
                options={dateTimePicker}
                onChange={(_, str, b) =>
                  this.handleFilter(b.element, { name: "endTime", value: str })
                }
              />
            </Form.Field>
            <Form.Field className="ticketsGroupSearch">
              <Button icon="search" primary onClick={this.fetchData} id="btnSearch" />
              <Button icon="close" color="red" onClick={this.handleClearSearch} />
            </Form.Field>
          </Form.Group>
        </Form>
        <div
          style={{
            top: 201,
            display: "block",
            width: "100%",
            zIndex: 5,
            backgroundColor: "#ffffff",
            padding: "0.6rem 0"
          }}
        >
        <Button
          disabled={selectedRestoreList.length < 1}
          primary
          content="Restore"
          onClick={() =>
            this.confirmOpen(
              this.state.selected,
              <RenderSelected
                title="Are you sure you want to restore the below transaction(s)?"
                selected={selectedRestoreList}
              />,
              this.restoreTickets,
              "restoreTicketsBtn"
            )
          }
          className="ticketsGroupSearch"
          id="restoreTicketsBtn"
        />
        <Button
          disabled={selectedVoidList.length < 1 || (!this.state.allowManagerVoid && this.state.eventHasWinner && !this.state.userIsSuper)}
          primary
          content="Void Ticket"
          onClick={() =>
            this.confirmOpen(
              this.state.selected,
              <RenderSelected
                title="Are you sure you want to void the below transaction(s)?"
                selected={selectedVoidList}
              />,
              this.voidTickets,
              "voidTicketsBtn"
            )
          }
          className="ticketsGroupSearch"
          id="voidTicketsBtn"
        />
          {freeTicketEnabled && (
            <Button
              primary
              content="Free Ticket"
              onClick={() =>
                this.confirmModalOpen(
                  0,
                  "Are you sure you'd like to generate a free ticket?",
                  this.freeTicket
                )
              }
              className="ticketsGroupSearch"
              disabled={this.state.eventHasWinner}
            />
          )}
          <Button
            primary
            content="Export Report"
            onClick={this.handleExport}
            className="ticketsGroupSearch"
          />
        </div>

        <Divider hidden />

        <ReactTable
          data={data}
          columns={columns}
          className="-striped -highlight eventTicketsTable"
          manual
          pages={pages} // Display the total number of pages
          loading={isLoading} // Display the loading overlay when we need it
          resizable={true}
          defaultPageSize={limit}
          minRows={0}
          collapseOnDataChange = {false}
          expanded={this.state.expanded}
          onExpandedChange={(newExpanded, index, event) => {
            const rowData = this.state.data[index[0]];
            const { customer_email, recipient_email, recipient_fname, recipient_lname } = rowData;

            if (newExpanded[index[0]] === false) {
              newExpanded = {}
            } else{
              this.setState({
                ticketsLoading: true,
                resendEmailId: recipient_fname != null && recipient_lname != null && recipient_email != null ? recipient_email : customer_email
              }, () => this.handleOnExpand(index));
              Object.keys(newExpanded).map(k => {
                newExpanded[k] = parseInt(k) === index[0] ? {} : false
              })
            }
            this.setState({ expanded: newExpanded });
          }}
          SubComponent={row => {
            const data = row.original;
            const tickets = this.state.ticketNumbers.status != 'error' ? this.state.ticketNumbers : null;
            const allowVoid = ((!this.state.eventHasWinner && !this.state.userIsSuper) || this.state.userIsSuper || this.state.allowManagerVoid);

            return (
              <Segment basic>
                <List divided verticalAlign='middle'>
                  <List.Item>
                    <List.Content floated='right'>{data.reference}</List.Content>
                    <List.Content>Reference</List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content floated='right'>{data.subtype}</List.Content>
                    <List.Content>Processor</List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content floated='right'>{data.status}</List.Content>
                    <List.Content>Status</List.Content>
                  </List.Item>
                  { data.customer_fname !== "" && data.customer_lname !== "" && (
                  <List.Item>
                    <List.Content floated='right'>{data.customer_fname} {data.customer_lname}</List.Content>
                    <List.Content>Customer name</List.Content>
                  </List.Item>
                  )}
                  <List.Item>
                    <List.Content floated='right'>{data.customer_email}</List.Content>
                    <List.Content>Customer Email</List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content floated='right'>{data.customer_phone}</List.Content>
                    <List.Content>Customer Phone</List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content floated='right' style={{ maxWidth: '50%' }}>
                        {this.state.ticketsLoading ?
                            <Loader active inline size="small" /> :
                            tickets !== null ? `${tickets}`.replace(/,/g, ", ") :
                            'No Tickets Found'
                        }
                    </List.Content>
                    <List.Content>Ticket Numbers</List.Content>
                  </List.Item>
                </List>
                {tickets != null && web_enabled && data.web_orderid > 0 && data.subtype != 'shopify' && (
                  <a href={`${this.context.settings.web.weburl}/print-tickets/?orderId=${data.web_orderid}&hash=${data.web_orderhash}`} target="_blank" rel="noopener noreferrer" className="ui button primary">View Ticket</a>
                )}
                {web_enabled && data.web_orderid > 0 && data.subtype != 'shopify' && (
                  <Modal
                    size="tiny"
                    trigger={<Button primary disabled={data.status === "void" || data.status === "refunded"}>Resend Email</Button>}
                    header='Resend Ticket'
                    content={<Input
                        label="Customer Email"
                        name="resendEmailId"
                        fluid
                        transparent
                        value={this.state.resendEmailId}
                        onChange={this.handleChange}
                      />}
                    actions={['Cancel', { key: 'done', content: 'Send', positive: true, onClick: () => this.handleResendEmail(data.web_orderid, data.customer_email) }]}
                  >
                  </Modal>
                )}
                { web_enabled
                  && data.web_orderid > 0
                  && data.subtype == 'shopify'
                  && data.recipient_fname != null
                  && data.recipient_lname != null
                  && data.recipient_email != null && (
                  <Modal
                    size="tiny"
                    trigger={<Button primary disabled={data.status === "void" || data.status === "refunded"}>Resend Email</Button>}
                    header='Resend Ticket'
                    content={<Input
                        label="Customer Email"
                        name="resendEmailId"
                        fluid
                        transparent
                        value={this.state.resendEmailId}
                        onChange={this.handleChange}
                      />}
                    actions={['Cancel', { key: 'done', content: 'Send', positive: true, onClick: () => this.handleResendEmail(data.web_orderid, data.recipient_email) }]}
                  >
                  </Modal>
                )}
                {((data.subtype == 'handpoint' && !this.state.handpoint_refunds_enabled) || data.payment_type == 'debit_card') && (
                  <Modal
                  size="tiny"
                  trigger={<Button primary disabled={!allowVoid || data.status === "void" || data.status === "refunded"}>Mark as Void</Button>}
                  header='Mark as Void'
                  content="This will only mark the order and tickets as void, you must login to the payment processor and manually issue a refund to complete the process."
                  actions={['Cancel', { key: 'done', content: 'Continue', positive: true, onClick: () => this.handleMarkAsVoid(data.id, data.status) }]}
                >
                </Modal>
                )}
              </Segment>
            );
          }}
          onSortedChange={sorted => this.setState({ sorted }, () => this.fetchData())}
          onPageChange={this.handlePageChange}
          onPageSizeChange={this.handleLimitChange}
        />
      </Segment>
    );
  }
}

EventTickets.contextType = AppContext;

export default EventTickets;
